import type { InitiativeStatusName, TrafficLight } from '@fluxus/shared';

/** Situação da iniciativa como selo (cor + ícone + texto), na lista, no detalhe e no mapa estratégico. */
export const INITIATIVE_STATUS_LIGHT: Record<InitiativeStatusName, TrafficLight> = {
  PLANNED: 'gray',
  IN_PROGRESS: 'blue',
  AT_RISK: 'yellow',
  DONE: 'green',
  SUSPENDED: 'gray',
  CANCELLED: 'red',
};
